import { useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { setChatBoxVisibility } from "store/actions";

const TogetherUserNotAllow = ({ isOpen, handleClose }) => {
  const dispatch = useDispatch();
  const handleVisibilityChanged = ({ visibility }) => {
    dispatch(setChatBoxVisibility("maximized"));
  };
  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader>Alert</ModalHeader>
      <ModalBody>
        <span>
          Sorry, you can't access Grow Together, as you don't have an active
          subscription. Please contact our{" "}
          <span
            className="cursor-pointer text-primary"
            onClick={handleVisibilityChanged}
          >
            customer support
          </span>{" "}
          team.
        </span>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-primary "
          onClick={() => {
            handleClose();
          }}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default TogetherUserNotAllow;
